module.exports = __webpack_public_path__ + "static/media/facebookIcon.40d87be4.png";